import { Injectable } from '@angular/core';

import { Observable, of } from 'rxjs';

import { BetPlacementError } from '../../../errors/bet-placement-error';
import { BetslipError } from '../../../errors/betslip-error';
import { OverallMaxWinPerUser } from '../../../errors/user/overall-max-win-per-user';
import { UnderMinimumCompulsoryOdds } from '../../../errors/user/under-minimum-compulsory-odds';
import { ErrorMessageCurrencySymbolFormatService } from '../error-message-currency-symbol-format.service';
import { MessageFormatter } from './message-formatter';

@Injectable()
export class GenericBetPlacementErrorMessageFormatter extends MessageFormatter<BetPlacementError> {
    constructor(private errorMessageCurrencySymbolFormatService: ErrorMessageCurrencySymbolFormatService) {
        super();
    }

    format(error: BetPlacementError): Observable<string> {
        return of(this.errorMessageCurrencySymbolFormatService.updateCurrencyPlaceholders(error.errorMessage));
    }

    canHandle(error: BetslipError): boolean {
        return (
            error instanceof BetPlacementError &&
            !!error.errorMessage &&
            !(error instanceof UnderMinimumCompulsoryOdds || error instanceof OverallMaxWinPerUser)
        );
    }
}
